export const cocktails = [ 'Vodka','Tequila',   "Whiskey", "Bourbon", "Gin", "Brandy", "Rum", "Scotch", "Cognac"]
export const mixers = [ "Grenadine", "Lemon Juice", "Simple Syrup", "Soda Water", "Tonic Water", "Ginger Ale", "Cranberry Juice", "Orange Juice", "Pineapple Juice", "Coffee"]

